import { CALENDAR_PROVIDERS } from "~/screens/Scheduling/ConfirmedVisit/constants/calendar-providers";
import { CALENDAR_URLS } from "~/screens/Scheduling/ConfirmedVisit/constants/calendar-urls";
import {
  formatCalendarDates,
  googleToIso,
} from "~/screens/Scheduling/ConfirmedVisit/utils/date";
import {
  convertTimeToTimeZone,
  TIMEZONE_TO_IANA,
  TIMEZONES,
} from "~/screens/Scheduling/InitialVisit/utils/date-time-utils";
import { ScheduleVisitResponse } from "~/services";

type CalendarProvider =
  (typeof CALENDAR_PROVIDERS)[keyof typeof CALENDAR_PROVIDERS];

export const addToCalendar = (
  eventTitle: string,
  appointment: ScheduleVisitResponse,
  provider: CalendarProvider,
  timezone: string,
) => {
  const appointmentDate = new Date(appointment.appointment.date);
  const convertedStartTime = convertTimeToTimeZone(
    appointment.appointment.startTime,
    TIMEZONES.ET.code,
    timezone,
    appointmentDate,
  );

  const title = `${eventTitle} ${appointment.provider.name} ${
    appointment.provider.title ? `, ${appointment.provider.title}` : ""
  }`;

  const { start, end } = formatCalendarDates(
    appointment.appointment.date,
    convertedStartTime,
    appointment.appointment.duration,
  );

  const ianaTimezone =
    TIMEZONE_TO_IANA[timezone] ?? TIMEZONE_TO_IANA[TIMEZONES.ET.code];
  const description =
    provider === CALENDAR_PROVIDERS.GOOGLE
      ? `Join the telehealth conference:\n${appointment.appointment.inviteLink}`
      : `Join the telehealth conference:%0A${appointment.appointment.inviteLink}`;

  if (provider === CALENDAR_PROVIDERS.GOOGLE) {
    const googleCalendarUrl = `${CALENDAR_URLS.GOOGLE}${encodeURIComponent(
      title,
    )}&dates=${start}/${end}&details=${encodeURIComponent(description)}&ctz=${encodeURIComponent(ianaTimezone)}`;

    window.open(googleCalendarUrl, "_blank");
  } else if (provider === CALENDAR_PROVIDERS.OUTLOOK) {
    const outlookUrl =
      CALENDAR_URLS.OUTLOOK +
      `&startdt=${encodeURIComponent(googleToIso(start))}` +
      `&enddt=${encodeURIComponent(googleToIso(end))}` +
      `&subject=${encodeURIComponent(title)}` +
      `&body=${encodeURIComponent(description)}`;

    window.open(outlookUrl, "_blank");
  }
};
